import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Consent {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  decidedAt: string | null;
  policyVersion: string | null;
}

interface ConsentState extends Consent {
  decide: (choice: { analytics: boolean; marketing: boolean }, policyVersion: string) => void;
  reset: () => void;
}

/**
 * Defaults to rejected. Nothing non-essential may fire until `decidedAt` is set, and the
 * only writes before that point are this store itself and the cart — both strictly
 * necessary for the shop to function.
 */
export const useConsent = create<ConsentState>()(
  persist(
    (set) => ({
      necessary: true,
      analytics: false,
      marketing: false,
      decidedAt: null,
      policyVersion: null,
      decide: (choice, policyVersion) =>
        set({ ...choice, decidedAt: new Date().toISOString(), policyVersion, necessary: true }),
      reset: () => set({ analytics: false, marketing: false, decidedAt: null, policyVersion: null }),
    }),
    { name: 'rozman.consent' },
  ),
);

export const analyticsAllowed = (): boolean => useConsent.getState().analytics;
